import React, {useCallback, useEffect, useState} from 'react';
import ManagementCompany from '../artifacts/src/contracts/ManagementCompany.sol/ManagementCompany'
import SPVWallet from '../artifacts/src/contracts/SPVWallet.sol/SPVWallet'
import {useWeb3React} from "@web3-react/core";
import styled, {css} from 'styled-components/macro'
import Spinner from "./Spinner";
import {AnimatePresence, motion} from "framer-motion";
import CreateProposalModal from "./CreateProposalModal";
import ProposalViewModal from "./ProposalViewModal";
import ERC20Token from '../artifacts/src/contracts/test/ERC20Token.sol/ERC20Token'
import CurrencyModal from "./CurrencyModal";
import {parseUnits} from "@ethersproject/units";

var BigNumber = require("big-number");

const DashboardPage = styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
    font-family: Lato;
    font-style: normal;
    z-index:2;
    min-height: 80vh;
`

const UpperArea = styled.div`
    width: 100%;
    min-width: 1440px;
    margin-top: -300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
    z-index: 1;
`

const Title = styled.div`
   
    height: 54px;
    
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 45px;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    
    color: rgba(240, 194, 53, 1);
`

const SubTitle = styled.div`
   
    height: 54px;
    
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 45px;
    text-align: center;
    letter-spacing: 0.03em;
    
    color: rgba(240, 194, 53, 1);
    
    margin-bottom: 45px;
    opacity: 0.4;
`

const RowTitle = styled.div`
   
    height: 54px;

    font-weight: bold;
    font-size: 30px;
    line-height: 180%;
    /* identical to box height, or 54px */

    text-transform: capitalize;

    color: #000000;
    margin-bottom: 31px;
`

const BalanceContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 70%;
    min-width: 1049px;
    height: 259px;
    border: 2px solid rgba(240, 194, 53, 1);
  
    background: linear-gradient(287.81deg, #161616 32.36%, rgba(22, 22, 22, 0.73) 99.22%);
    box-shadow: 26px 24px 90px 0px rgba(31, 26, 51, 0.13);
`

const BalanceDisplay = styled.div`
    display: flex;
    flex-direction: column;
    width: 33%;
    align-items: center;
`

const BalanceNumber = styled.div`
    margin-top: 56px;
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 109%;
    /* or 52px */
    
    color: #F0C235;
`

const BalanceLabel = styled.div`
    margin-top: 15px;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 109%;
    /* identical to box height, or 35px */


    color: #FFFFFF;
`

const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0px;

    width: 80%;
    margin-left: 10%;
    margin-top: 14px;
    margin-bottom: 67px;
`


const AddressZero = '0x0000000000000000000000000000000000000000';

const SPVWalletPage = (() => {
    const web3Context = useWeb3React();
    const [ManagementCompanySC] = useState({
        address: process.env.REACT_APP_MCADMIN_ADDRESS,
        abi: ManagementCompany.abi
    });

    const [SPVWalletSC, setSPVWalletSC] = useState({
        address: process.env.REACT_APP_SPVWALLET_ADDRESS,
        abi: SPVWallet.abi
    });

    const currencies = CurrencyModal();

    const [USDCInfo, setUSDCInfo] = useState({
        balance: 0,
        decimal: 6,
        name: "USDC"
    });
    const [USDTInfo, setUSDTInfo] = useState({
        balance: 0,
        decimal: 6,
        name: "USDT"
    });
    const [DAIInfo, setDAIInfo] = useState({
        balance: 0,
        decimal: 18,
        name: "DAI"
    });

    const [requestInfo, setRequestInfo] = useState();

    const [boardMembers, setBoardMembers] = useState([]);

    const loadBoardMembers = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const ManagementCompanyContract = new ethLibrary.Contract(
            ManagementCompanySC.abi,
            ManagementCompanySC.address
        );

        const activeBoardMembers = await ManagementCompanyContract.methods
            .getActiveMCBoard()
            .call();

        setBoardMembers(activeBoardMembers.slice(1));
    }, [web3Context, ManagementCompanySC]);

    const loadCurrentRequest = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const SPVWalletContract = new ethLibrary.Contract(
            SPVWalletSC.abi,
            SPVWalletSC.address
        );

        const currentRequest = await SPVWalletContract.methods
            .request()
            .call();

        const voteFlags = await SPVWalletContract.methods
            .getRequestVoteFlags()
            .call();

        let currencyName = "N/A";
        let CURRENCYBASE = 10 ** 18;
        let selectedCurrency = currencies.find(c => c.address.toString().toLowerCase() ===  currentRequest[0].toString().toLowerCase());
        if(selectedCurrency !== undefined) {
            CURRENCYBASE = 10 ** selectedCurrency.decimal;
            currencyName = selectedCurrency.name;
        }
        let newRequestObject = {
            currency: currentRequest[0],
            amount: currentRequest[1],
            to: currentRequest[2],
            voteFlags: voteFlags,
            currencyName: currencyName,
            currencyBase: CURRENCYBASE
        };

        setRequestInfo(newRequestObject);

    }, [web3Context, SPVWalletSC]);


    const loadTokenBalance = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const USDTInfo = currencies.find(c => c.name === "USDT");
        const USDTContract = new ethLibrary.Contract(
            ERC20Token.abi,
            USDTInfo.address
        );
        const USDTBalance = await USDTContract.methods
            .balanceOf(process.env.REACT_APP_SPVWALLET_ADDRESS)
            .call();

        setUSDTInfo({
            balance: USDTBalance / (10 ** USDTInfo.decimal),
            decimal: USDTInfo.decimal,
            address: USDTInfo.address,
            name: USDTInfo.name
        });

        const USDCInfo = currencies.find(c => c.name === "USDC");
        const USDCContract = new ethLibrary.Contract(
            ERC20Token.abi,
            USDCInfo.address
        );

        const USDCBalance = await USDCContract.methods
            .balanceOf(process.env.REACT_APP_SPVWALLET_ADDRESS)
            .call();

        setUSDCInfo({
            balance: USDCBalance / (10 ** USDCInfo.decimal),
            decimal: USDCInfo.decimal,
            address: USDCInfo.address,
            name: USDCInfo.name
        });

        const DAIInfo = currencies.find(c => c.name === "DAI");
        const DAIContract = new ethLibrary.Contract(
            ERC20Token.abi,
            DAIInfo.address
        );

        const DAIBalance = await DAIContract.methods
            .balanceOf(process.env.REACT_APP_SPVWALLET_ADDRESS)
            .call();


        setDAIInfo({
            balance: DAIBalance / (10 ** DAIInfo.decimal),
            decimal: DAIInfo.decimal,
            address: DAIInfo.address,
            name: DAIInfo.name
        });

    }, [web3Context, SPVWalletSC]);

    const createRequest = useCallback(async(currency, to, amount) => {
        const ethLibrary = web3Context.library.eth;
        const SPVWalletContract = new ethLibrary.Contract(
            SPVWalletSC.abi,
            SPVWalletSC.address
        );

        let CURRENCYBASE = 10 ** 18;
        let decimal = 18;
        let dec = web3Context.library.utils.toBN(decimal);
        let selectedCurrency = currencies.find(c => c.address.toString().toLowerCase() === currency.toString().toLowerCase());
        if(selectedCurrency !== undefined) {
            decimal = selectedCurrency.decimal;
        }

        let exactAmount;

        // work around
        if(amount >= 0) {
            exactAmount =  parseUnits(amount, decimal);
        } else {
            exactAmount = 0;
        }

        await SPVWalletContract.methods
            .createFundTransferRequest(currency, exactAmount, to)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });

    }, [web3Context, SPVWalletSC]);

    const approveRequest = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const SPVWalletContract = new ethLibrary.Contract(
            SPVWalletSC.abi,
            SPVWalletSC.address
        );

        await SPVWalletContract.methods
            .approveFundTransferRequest()
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [web3Context, SPVWalletSC]);

    const loadSCAddress = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const MCAdminContract = new ethLibrary.Contract(
            ManagementCompany.abi,
            process.env.REACT_APP_MCADMIN_ADDRESS
        );

        const SPV = await MCAdminContract.methods.SPVWalletAddress().call();

        setSPVWalletSC({
            address: SPV,
            abi: SPVWallet.abi
        });

    }, [web3Context]);

    useEffect(() => {
        if(web3Context.active) {
            loadSCAddress();
            loadBoardMembers();
            loadTokenBalance();
            loadCurrentRequest();
        }
    },[web3Context]);

    return (
        <AnimatePresence>
            {
                web3Context.account === undefined || !boardMembers.includes(web3Context.account)? (
                    <DashboardPage>
                        <Spinner/>
                    </DashboardPage>) : (<DashboardPage>
                        <UpperArea>
                            <Title>SPV Wallet Balance</Title>
                            <SubTitle>Address: {process.env.REACT_APP_SPVWALLET_ADDRESS}</SubTitle>
                            <BalanceContainer>
                                <BalanceDisplay>
                                    <BalanceNumber>
                                        {USDCInfo.balance}
                                    </BalanceNumber>
                                    <BalanceLabel>
                                        USDC
                                    </BalanceLabel>
                                </BalanceDisplay>
                                <BalanceDisplay>
                                    <BalanceNumber>
                                        {DAIInfo.balance}
                                    </BalanceNumber>
                                    <BalanceLabel>
                                        DAI
                                    </BalanceLabel>
                                </BalanceDisplay>
                                <BalanceDisplay>
                                    <BalanceNumber>
                                        {USDTInfo.balance}
                                    </BalanceNumber>
                                    <BalanceLabel>
                                        USDT
                                    </BalanceLabel>
                                </BalanceDisplay>
                            </BalanceContainer>
                        </UpperArea>
                        <FlexContainer>
                            <RowTitle>Current Transfer Request</RowTitle>
                            {requestInfo === undefined || requestInfo.currency === AddressZero ? ("") : (
                            <ProposalViewModal
                                boxLabel = {(
                                    <div style={{"fontSize": "18px"}}>
                                        {"Transfer amount: " + requestInfo.amount/requestInfo.currencyBase + " "  + requestInfo.currencyName}
                                        <br/>
                                        {"Receiving Address: " + requestInfo.to.substring(0,7)+ "..." + requestInfo.to.substring(requestInfo.to.length - 6)}
                                    </div>
                                )}
                                requestText = {(
                                    <div>
                                        {"Transfer amount: " + requestInfo.amount + " "  + requestInfo.currencyName}
                                        <br/>
                                        {"Receiving Address: " + requestInfo.to}
                                    </div>
                                )}
                                action = {approveRequest}
                                header = "TRANSFER REQUEST PROPOSAL"
                                boardMembers = {boardMembers}
                                votingResults = {requestInfo.voteFlags}
                                caller={web3Context.account}
                            />
                            )}
                        </FlexContainer>
                        <FlexContainer>
                            <RowTitle>Create New Transfer Request</RowTitle>
                                <CreateProposalModal
                                    header = "Create Transfer Proposal"
                                    label = "Create Request"
                                    note = {null}
                                    action = {createRequest}
                                    boardMembers = {boardMembers}
                                />
                        </FlexContainer>
                    </DashboardPage>
                )
            }
        </AnimatePresence>
    );
});

export default SPVWalletPage;
